import script from "./AuthInvitation.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthInvitation.vue?vue&type=script&setup=true&lang=js"

import "./AuthInvitation.vue?vue&type=style&index=0&id=37cd6407&lang=css"
import "./AuthInvitation.vue?vue&type=style&index=1&id=37cd6407&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37cd6407"]])

export default __exports__